import React, { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import colors from '../../constants/colors.constants';

export type TypoType =
  | 'b-30'
  | 'b-24'
  | 'b-18'
  | 'b-16'
  | 'm-18'
  | 'm-16'
  | 'm-14'
  | 'm-12'
  | 'b-14'
  | 'm-13'
  | 'r-18'
  | 'r-12'
  | 'r-14'
  | 'r-16';

export interface TypoProps {
  type?: TypoType;
  color?: string;
  children?: ReactNode;
  style?: CSSProperties;
}

function Typo(props: TypoProps) {
  const { style, type = 'b-16', color = colors.defaultTypo, children } = props;
  return (
    <StyledTypo $type={type} $color={color} style={style}>
      {children}
    </StyledTypo>
  );
}

export default Typo;

const StyledTypo = styled.span<{ $type: TypoType; $color: string }>`
  color: ${({ $color }) => $color};
  font-weight: ${(props) => {
    const { $type } = props;
    switch ($type) {
      case 'b-30':
      case 'b-24':
      case 'b-18':
      case 'b-16':
      case 'b-14':
        return 600;
      case 'm-16':
      case 'm-14':
      case 'm-13':
      case 'm-12':
        return 500;
      case 'r-16':
      case 'r-18':
      case 'r-14':
      case 'r-12':
        return 400;
      default:
        return 400;
    }
  }};
  font-size: ${(props) => {
    const { $type } = props;
    switch ($type) {
      case 'b-30':
        return '30px';
      case 'b-24':
        return '24px';
      case 'b-18':
      case 'm-18':
      case 'r-18':
        return '18px';
      case 'b-16':
      case 'm-16':
      case 'r-16':
        return '16px';
      case 'b-14':
      case 'm-14':
      case 'r-14':
        return '14px';
      case 'm-13':
        return '13px';
      case 'r-12':
      case 'm-12':
        return '12px';
      default:
        return '14px';
    }
  }};
`;
